import * as React from 'react';

import {LoadingText} from 'shells/loading-placeholder/loading-text';

import type {ThreadType} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {HeaderStatusButton} from '../shared-components/header-status-button/header-status-button';

import {useGetFacebookIntegration} from './graphql/hooks/use-get-facebook-integration';

type Props = {
    threadType: ThreadType;
};

export function FacebookHeaderButtons(props: Props) {
    const {user} = useGetSessionUser();
    const {facebookIntegration, isLoading} = useGetFacebookIntegration();

    const userCanAccessSetup = Boolean(user && user.permissions.canAccessSetup);
    const isConnected = Boolean(facebookIntegration && facebookIntegration.hasAuthToken);
    const isEnabled = Boolean(facebookIntegration && facebookIntegration.isEnabled);

    if (!userCanAccessSetup) {
        return null;
    } else if (isLoading) {
        return <LoadingText height={31} width={200} />;
    }

    return (
        <HeaderStatusButton
            isConnected={isConnected}
            isEnabled={isEnabled}
            threadType={props.threadType}
        />
    );
}
